export type SvgEl = React.HTMLAttributes<HTMLOrSVGElement>;

export const IconStar: React.FC<SvgEl> = (props: SvgEl) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12" {...props}>
      <path d="M0 4.6a.44.44 0 01.41-.31l3.06-.43.77-.11a.18.18 0 00.17-.13L6.12.28A.44.44 0 016.43 0a.36.36 0 01.38.17 1.78 1.78 0 01.17.3l1.61 3.16a.2.2 0 00.18.12l3.75.53h.1a.38.38 0 01.36.26.39.39 0 01-.14.42l-2.77 2.6a.24.24 0 00-.08.25l.66 3.71a.35.35 0 01-.14.38.41.41 0 01-.44 0l-1.72-.88-1.73-.88a.23.23 0 00-.24 0l-3.42 1.74a.42.42 0 01-.34.06.37.37 0 01-.29-.39l.39-2.17L3 7.76a.2.2 0 00-.07-.16L.25 5.05a2.35 2.35 0 01-.26-.29z" />
    </svg>
  );
};
